import React, { useEffect, useState } from "react";
import { Drawer, TextField, Button, Box, Typography } from "@mui/material";
import NodeTypeSelector from "./NodeTypeSelector";

const NodeEditor = ({ selectedNode, setSelectedNode, updateNode }) => {
  const [nodeData, setNodeData] = useState({ label: "", buttons: [] });

  useEffect(() => {
    if (selectedNode) {
      setNodeData({ label: selectedNode.label, buttons: selectedNode.buttons || [] });
    }
  }, [selectedNode]);

  const handleSave = () => {
    updateNode(selectedNode.id, nodeData);
    setSelectedNode(null);
  };

  const addButton = () => {
    setNodeData((prev) => ({
      ...prev,
      buttons: [...prev.buttons, { id: `btn-${prev.buttons.length + 1}`, label: `Botão ${prev.buttons.length + 1}` }],
    }));
  };

  return (
    <Drawer anchor="right" open={!!selectedNode} onClose={() => setSelectedNode(null)}>
      <Box sx={{ width: 300, padding: 2 }}>
        <Typography variant="h6">Editar Nó</Typography>

        <TextField
          label="Nome do Nó"
          value={nodeData.label}
          onChange={(e) => setNodeData({ ...nodeData, label: e.target.value })}
          fullWidth
          margin="normal"
        />

        {nodeData.buttons.map((button, index) => (
          <TextField
            key={button.id}
            label={`Botão ${index + 1}`}
            value={button.label}
            onChange={(e) => {
              const newButtons = [...nodeData.buttons];
              newButtons[index].label = e.target.value;
              setNodeData({ ...nodeData, buttons: newButtons });
            }}
            fullWidth
            margin="normal"
          />
        ))}

        <NodeTypeSelector nodeType={nodeData.type} setNodeType={(type) => setNodeData({ ...nodeData, type })} />

        <Button variant="outlined" onClick={addButton} fullWidth sx={{ marginTop: 1 }}>
          Adicionar Botão
        </Button>

        <Box sx={{ display: "flex", justifyContent: "space-between", marginTop: 3 }}>
          <Button variant="contained" color="primary" onClick={handleSave}>
            Salvar
          </Button>
          <Button variant="contained" color="error" onClick={() => setSelectedNode(null)}>
            Cancelar
          </Button>
        </Box>
      </Box>
    </Drawer>
  );
};

export default NodeEditor;
